import dompurify from 'dompurify';

const richTextSanitizer = dompurify(window);

const SANITIZE_RICH_AREA_OPTIONS = {
  ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'ul', 'ol', 'li', 'a'],
  ALLOWED_ATTR: ['href', 'title'],
  ALLOW_DATA_ATTR: false,
  ALLOW_ARIA_ATTR: false,
};

export const sanitizeRichAreaHtml = (html: string) => String(dompurify.sanitize(html, SANITIZE_RICH_AREA_OPTIONS));

richTextSanitizer.addHook('afterSanitizeAttributes', node => {
  if (node.nodeName.toLowerCase() !== 'a') return;

  if (!node.hasAttribute('href')) {
    node.removeAttribute('target');
    node.removeAttribute('rel');
    return;
  }

  node.setAttribute('target', '_blank');
  node.setAttribute('rel', 'noopener noreferrer');
});

export const sanitizeRichTextHtml = (html: string) => String(richTextSanitizer.sanitize(html));
